import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.string.starts-with.js";

import { mapState, mapActions } from 'vuex';
import downloadCsv from 'download-csv';
export default {
  name: 'DeviceStatus',
  data: function data() {
    return {
      sortBy: 'INV 名稱',
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 100],
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      isOnlyPV: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('deviceStatus', ['deviceStatusChartOptions', 'tableField', 'tableData', 'dataTime'])), mapState(['dark', 'tableThColor', 'factoryData'])), {}, {
    rows: function rows() {
      return this.tableData.length;
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions(['asyncLastSingleDoc', 'updateDevicesStatusState'])), mapActions('deviceStatus', ['handleTableField'])), {}, {
    // 發電離群的 hover 說明
    deviationTitle: function deviationTitle(row) {
      var deviation = row['發電偏離度 (%)'];
      var basis = row._peerBasis;
      var direction = deviation > 0 ? '高' : '低';
      var magnitude = Math.abs(deviation);
      var yieldText = function yieldText(v) {
        return "".concat(v.toFixed(2), " kWh/kWp");
      };
      var capText = basis.capMin === basis.capMax ? "".concat(basis.capMin, " kWp") : "".concat(basis.capMin, "~").concat(basis.capMax, " kWp");
      var groupText = "".concat(basis.count, " \u53F0\u540C\u5BB9\u91CF\u6A5F\u7D44\uFF08").concat(capText, "\uFF09");

      // 完全沒發電，與日照強弱無關，故不提門檻
      if (row._peerMode === 'dead') {
        return ['今日完全沒有發電，瞬時功率也是 0', "\u540C\u5115\u4ECD\u5728\u767C\u96FB\uFF0C\u57FA\u6E96 ".concat(yieldText(basis.ref), "\uFF0C\u672C\u53F0 ").concat(yieldText(0)), "\u6BD4\u8F03\u57FA\u790E\uFF1A".concat(groupText)].join('\n');
      }

      // 同容量僅兩台時無第三方可投票，只能指出這一對有異常，無法歸屬
      if (row._peerMode === 'pair') {
        return ['同容量僅兩台，彼此差異過大 — 無法判斷何者異常，請至現場確認', "\u672C\u53F0 ".concat(yieldText(basis.self), "\uFF0C\u53E6\u4E00\u53F0 ").concat(yieldText(basis.ref), "\uFF08\u672C\u53F0").concat(direction, " ").concat(magnitude, "%\uFF09"), "\u6BD4\u8F03\u57FA\u790E\uFF1A".concat(groupText, "\uFF0C\u9580\u6ABB \xB1").concat(basis.limit, "%")].join('\n');
      }
      return ["\u4ECA\u65E5\u767C\u96FB\u91CF".concat(direction, "\u65BC\u540C\u5115\u4E2D\u4F4D\u6578 ").concat(magnitude, "%"), "\u540C\u5115\u4E2D\u4F4D\u6578 ".concat(yieldText(basis.ref), "\uFF0C\u672C\u53F0 ").concat(yieldText(basis.self)), "\u6BD4\u8F03\u57FA\u790E\uFF1A".concat(groupText), "\u9580\u6ABB \xB1".concat(basis.limit, "%")].join('\n');
    },
    downloadAnalysis: function downloadAnalysis() {
      // 移除底線開頭的內部欄位 (_cellVariants、_peerMode)
      var downloadData = this.tableData.map(function (obj) {
        return Object.fromEntries(Object.entries(obj).filter(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 1),
            key = _ref2[0];
          return !key.startsWith('_');
        }));
      });
      downloadCsv(downloadData, {}, '變流器詳細資訊.csv');
    }
  }),
  watch: {
    isOnlyPV: function isOnlyPV(newValue, _oldValue) {
      if (newValue) {
        this.handleTableField(true);
      } else {
        this.handleTableField();
      }
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.factoryData.length) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return _this.asyncLastSingleDoc(_this.$route.query.siteName);
            case 3:
              _this.updateDevicesStatusState();
              _this.handleTableField();
            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};